export interface IContactRequest {
  email: string
  fullName: string
  message: string
}
